import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { message } from "antd";
import SideMenu from "../components/Header/SideMenu";
import HeroSvg from "../components/Layout/HeroSvg";
import CryptoJS from "crypto-js";
import { setActiveButton } from "../redux/features/footerMenuSlice";
import {
  ChevronLeftSvg,
  CallSvg,
  ListSvg,
  AsteriskSvg,
  EmailSvg,
  PersonSvg,
} from "../components/AllSvgModulesExport/LoginSvg";
import { setUser } from "../redux/features/userSlice";
import "./css/UserWallet.css";
import { apiClient } from "../config/api.client";

const UserWallet = () => {
  const { user } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [sideMenu, setSideMenu] = useState(false);
  const [payments, setPayments] = useState([]);
  const [form, setForm] = useState({});

  // get wallet history
  async function getUserWalletHistory() {
    try {
      const res = await apiClient.get("/wallet/history", {
        params: {
          page: 1,
          limit: 10,
        },
      });
      if (res.data?.success) {
        const mapped = (res.data.data?.transactions || []).map((t) => ({
          product: t?.description || "",
          type: t?.transactionType === "debit" ? "order" : "addmoney",
          amount: t?.amount,
          orderId: t?.reference || t?._id,
          balanceAfter: t?.balanceAfter,
          balanceBefore: t?.balanceBefore,
          createdAt: t?.createdAt,
          admin: t?.createdByType === "admin",
        }));
        setPayments(mapped);
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    if (user?.phone || user?.mobile) {
      getUserWalletHistory();
    }
  }, []);

  const onClose = () => {
    dispatch(setActiveButton("home"));
    navigate("/");
    localStorage.setItem("activeButton", "home");
  };

  return (
    <>
      <div className={`account-modal-container d-lg-none d-md-none `}>
        <HeroSvg />
        <div className="account-modal-container-content">
          <div className="top-left-content">
            <div className="box-1 center" onClick={onClose}>
              <ChevronLeftSvg />
            </div>
            <h2 className="mb-0">Wallet</h2>
          </div>
          <div
            className="top-right-content box-2 center"
            onClick={() => setSideMenu(!sideMenu)}
          >
            <ListSvg />
          </div>
        </div>
        <div className="mobile-wallet-history d-block d-md-block d-lg-none">
          {payments?.length === 0 ? (
            <p className="m-0 text-center">No Record Found</p>
          ) : (
            payments.map((item, index) => {
              return (
                <div className="history">
                  <div className="item">
                    <h4 className="m-0">{item?.product}</h4>
                    <span
                      className={`${
                        item?.type === "order"
                          ? "text-danger"
                          : item?.type === "withdraw"
                          ? "text-danger"
                          : item?.type === "pending"
                          ? "text-warning"
                          : "text-success"
                      }`}
                    >
                      {item?.type === "order"
                        ? "-"
                        : item?.type === "withdraw"
                        ? "-"
                        : "+"}
                      {item?.amount}
                    </span>
                  </div>
                  <div className="item">
                    <span className="text-muted">
                      <small>{item?.orderId}</small>
                    </span>
                    <span className="text-muted">
                      <small>Avl Balance: ₹{item?.balanceAfter}</small>
                    </span>
                  </div>
                  <div className="item">
                    <span className="text-success">
                      <small>
                        {new Date(item?.createdAt).toLocaleString("default", {
                          day: "numeric",
                          month: "numeric",
                          year: "numeric",
                          hour: "numeric",
                          minute: "numeric",
                          second: "numeric",
                        })}
                      </small>
                    </span>
                    <span className="text-primary">
                      <b>
                        <small>{item?.type.toUpperCase()}</small>
                      </b>
                    </span>
                  </div>
                  {index !== payments.length - 1 && <hr />}
                </div>
              );
            })
          )}
        </div>
      </div>
      <SideMenu sideMenu={sideMenu} setSideMenu={setSideMenu} />
    </>
  );
};

export default UserWallet;
